module.exports = __webpack_public_path__ + "img/big-fight.bc66de62.jpg";